import deJson from "../../../intl-web-2/compiled/de-DE.json";
import gbJson from "../../../intl-web-2/compiled/en-GB.json";
import enJson from "../../../intl-web-2/compiled/en-US.json";
import esJson from "../../../intl-web-2/compiled/es-ES.json";
import frJson from "../../../intl-web-2/compiled/fr-FR.json";
import deJsonDS from "../../../ps-design-system/intl-shared-component/compiled/de-DE.json";
import gbJsonDS from "../../../ps-design-system/intl-shared-component/compiled/en-GB.json";
import enJsonDS from "../../../ps-design-system/intl-shared-component/compiled/en-US.json";
import esJsonDS from "../../../ps-design-system/intl-shared-component/compiled/es-ES.json";
import frJsonDS from "../../../ps-design-system/intl-shared-component/compiled/fr-FR.json";

import { Locale } from "./i18n.types";

const getLocaleMessages = (locale: Locale) => {
  switch (locale?.toLowerCase()) {
    case "fr-fr":
      return { ...frJson, ...frJsonDS };
    case "en-gb":
      return { ...gbJson, ...gbJsonDS };
    case "de-de":
      return { ...deJson, ...deJsonDS };
    case "es-es":
      return { ...esJson, ...esJsonDS };
    case "en-us":
    default:
      return { ...enJson, ...enJsonDS };
  }
};

export { getLocaleMessages };
